class ProductGridAddToCart {
  constructor(container) {
    this.container = container;
    this.form = container.querySelector('form');
    this.addToCartBtn = container.querySelector('[data-add-to-cart]');
    this.addToCartText = container.querySelector('[data-add-to-cart-text]');
    this.settings = {
      strings: {
        soldOut: theme.strings.soldOut,
        unavailable: theme.strings.unavailable,
        addToCart: 'Add To Cart',
      },
      classes: {
        disabled: 'disabled',
        loading: 'btn--loading'
      }
    };

    this.init();
  }

  init() {
    if (!this.form || !this.addToCartBtn) return;

    this.updateButtonState();

    this.addToCartBtn.addEventListener('click', (event) => {
      event.preventDefault();
      this.addToCart();
    });
  }

  updateButtonState() {
    const variantIdInput = this.form.querySelector('input[name="id"]');
    if (!variantIdInput) return;

    const variantId = variantIdInput.value;
    const variantAvailable = variantId && variantId !== "null" && variantId !== "";

    if (variantAvailable) {
      this.addToCartBtn.classList.remove(this.settings.classes.disabled);
      this.addToCartBtn.disabled = false;
      if (this.addToCartText) {
        this.addToCartText.textContent = this.settings.strings.addToCart;
      }
    } else {
      this.addToCartBtn.classList.add(this.settings.classes.disabled);
      this.addToCartBtn.disabled = true;
      if (this.addToCartText) {
        this.addToCartText.textContent = this.settings.strings.soldOut;
      }
    }
  }

  addToCart() {
    if (this.addToCartBtn.disabled) return;

    this.addToCartBtn.classList.add(this.settings.classes.loading);
    const formData = new FormData(this.form);

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Accept': 'application/json'
      },
      body: formData
    })
    .then(response => response.json())
    .then(data => {
      this.addToCartBtn.classList.remove(this.settings.classes.loading);

      // Dispatch event that theme.CartDrawer listens for to open cart drawer
      const event = new CustomEvent('ajaxProduct:added', { detail: data });
      document.dispatchEvent(event);      

      // Reload if on cart page
      if (document.body.classList.contains('template-cart')) {
        window.scrollTo(0, 0);
        location.reload();
      }
    })
    .catch(error => {
      this.addToCartBtn.classList.remove(this.settings.classes.loading);
      console.error('Add to cart failed:', error);
      alert('Failed to add product to cart');
    });
  }
}

// Initialize for every product grid item container on DOM load
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.grid-product__button').forEach(container => {
    new ProductGridAddToCart(container);
  });
});


window.addEventListener('scroll', function() {
  const btn = document.querySelector('.product-block .add-to-cart');
  if (!btn) return;
  if (window.scrollY > 300) {
    btn.classList.add('add-sticky');
  } else {
    btn.classList.remove('add-sticky');
  }
});


window.setGridHeight = (selector) => {
  this.heightArray = [];
  this.offsetArrayArray = [];
  this.sectionArray = [];

  document.querySelectorAll(selector).forEach((grid, i) => {
    var tmp = {
      index: i,
      offsetheight: grid.closest(`[data-equal]`).offsetTop,
    };
    this.offsetArrayArray.push(tmp);
  });

  this.diffrentsHeights = [];
  this.offsetArrayArray.forEach(function (e) {
    if (this.diffrentsHeights.includes(e.offsetheight) == false) {
      this.diffrentsHeights.push(e.offsetheight);
    }
  });

  this.diffrentsHeights.forEach(function (e) {
    var data = [];
    for (var i = 0; i < this.offsetArrayArray.length; i++) {
      if (this.offsetArrayArray[i].offsetheight == e) {
        data.push(this.offsetArrayArray[i]);
      }
    }

    var getAllHeightArray = [];
    data.forEach(function (ele) {
      document.querySelectorAll(selector)[ele.index].removeAttribute("style");
      getAllHeightArray.push(document.querySelectorAll(selector)[ele.index].offsetHeight);
    });

    var getMaxHeight = Math.max.apply(Math, getAllHeightArray);
    data.forEach(function (ele) {
      document.querySelectorAll(selector)[ele.index].style.minHeight = getMaxHeight + "px";
    });
  });
};

window.setGridHeight(".grid-product .grid__item-image-wrapper");

setTimeout(() => {
  window.setGridHeight(".grid-product .grid__item-image-wrapper");
}, "1000");

window.onresize = function () {
  window.setGridHeight(".grid-product .grid__item-image-wrapper");
};

